import trackMediaEvents from "../../common/trackMediaEvents";

export default () => {
  document
    .querySelectorAll(".js-audio-component .js-audio-player-source")
    .forEach((el, i) => {
      const audioComponentRoot = el.closest(".js-audio-component");
      const title = audioComponentRoot.dataset.title || "";

      trackMediaEvents(el, title);
    });
};
